import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// Application routing
const Infrastructure = Loadable(lazy(() => import('views/infrastructure/Infrastructure')));
const LocationsList = Loadable(lazy(() => import('views/locations/LocationsList')));
const InfrastructureManageEntity = Loadable(
  lazy(() => import('views/infrastructure/InfrastructureManageEntity'))
);
const LocationManagement = Loadable(lazy(() => import('views/locations/LocationManagement')));
const LocationDetails = Loadable(lazy(() => import('views/locations/LocationDetails')));
const LocationDashboard = Loadable(lazy(() => import('views/locations/LocationDashboard')));
const ProdForecastDetails = Loadable(
  lazy(() => import('views/production-forecast/ProdForecastDetails'))
);
const ForecastsList = Loadable(lazy(() => import('views/forecasts/ForecastsList')));
const ForecastManagement = Loadable(lazy(() => import('views/forecasts/ForecastManagement')));
const SourcesList = Loadable(lazy(() => import('views/sources/SourcesList')));
const TurbinesList = Loadable(lazy(() => import('views/turbines/TurbinesList')));
const TurbinesManagement = Loadable(lazy(() => import('views/turbines/TurbinesManagement')));
const PeriodicShedulesManagement = Loadable(
  lazy(() => import('views/periodic-schedules/PeriodicShedulesManagement'))
);
const TurbineDetails = Loadable(lazy(() => import('views/turbines/TurbineDetails')));
const SourcesManagement = Loadable(lazy(() => import('views/sources/SourcesManagement')));
const Comparison = Loadable(lazy(() => import('views/forecast-comparison/Comparison')));
const ValidatorBacktest = Loadable(
  lazy(() => import('views/validator-backtests/ValidatorBacktest'))
);
const VariablesList = Loadable(lazy(() => import('views/variables/VariablesList')));
const VariablesManagement = Loadable(lazy(() => import('views/variables/VariablesManagement')));
const Metrics = Loadable(lazy(() => import('views/metrics/Metrics')));
const AccuracyRanking = Loadable(lazy(() => import('views/accuracy-ranking/AccuracyRanking')));
const VariableData = Loadable(lazy(() => import('views/variable-data/VariableData')));
const UnavailabilitiesManagement = Loadable(
  lazy(() => import('views/unavailabilities/UnavailabilitiesManagement'))
);

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <Infrastructure />
    },
    {
      path: '/infrastructure',
      element: <Navigate to="/" replace />
    },
    {
      path: '/infrastructure/manage_entity',
      element: <InfrastructureManageEntity />
    },
    {
      path: '/locations',
      element: <LocationsList />
    },
    {
      path: '/locations/management/create',
      element: <LocationManagement />
    },
    {
      path: '/locations/management/:id',
      element: <LocationManagement />
    },
    {
      path: '/locations/:id',
      element: <LocationDetails />
    },
    {
      path: '/locations/:id/dashboard',
      element: <LocationDashboard />
    },
    {
      path: '/locations/:entityId/production_forecasts/:id',
      element: <ProdForecastDetails />
    },
    {
      path: '/turbines',
      element: <TurbinesList />
    },
    {
      path: '/turbines/:id',
      element: <TurbineDetails />
    },
    {
      path: '/turbines/:entityId/production_forecasts/:id',
      element: <ProdForecastDetails />
    },
    {
      path: '/turbines/management/create',
      element: <TurbinesManagement />
    },
    {
      path: '/turbines/management/:id',
      element: <TurbinesManagement />
    },
    {
      path: '/forecasts',
      element: <ForecastsList />
    },
    {
      path: '/forecasts/management/create',
      element: <ForecastManagement />
    },
    {
      path: '/forecasts/management/:id',
      element: <ForecastManagement />
    },
    {
      path: '/sources',
      element: <SourcesList />
    },
    {
      path: '/sources/management/create',
      element: <SourcesManagement />
    },
    {
      path: '/sources/management/:id',
      element: <SourcesManagement />
    },
    {
      path: '/periodic_schedules/management/create',
      element: <PeriodicShedulesManagement />
    },
    {
      path: '/periodic_schedules/management/:id',
      element: <PeriodicShedulesManagement />
    },
    {
      path: '/comparison',
      element: <Comparison />
    },
    {
      path: '/validator-backtests',
      element: <ValidatorBacktest />
    },
    {
      path: '/variables',
      element: <VariablesList />
    },
    {
      path: '/variables/management/:id',
      element: <VariablesManagement />
    },
    {
      path: '/variable-data',
      element: <VariableData />
    },
    {
      path: '/metrics',
      element: <Metrics />
    },
    {
      path: '/accuracy-ranking',
      element: <AccuracyRanking />
    },
    {
      path: '/unavailabilities',
      element: <UnavailabilitiesManagement />
    }
  ]
};

export default MainRoutes;
